import React, {useLayoutEffect, useRef, useState} from 'react';
import ResponsiveComponent from "../Common/ResponsiveComponent";
import IframeWidget from "../../utils/IframeWidget";
import {Modal} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import RoundedIcon from "../Common/RoundedIcon";
import LoadingContainer from "../Common/LoadingContainer";

interface Props {
    bodyContent: React.ReactNode;
    headerIcon?: JSX.Element;
    headerIconClassName?: string;
    title: string;
    description?: string;
    show: boolean;
    onHide?: () => void;
    onShow?: () => void;
    primaryButton?: JSX.Element;
    cancelButton?: true;
    secondaryButton?: JSX.Element;
    loading?: boolean;
}

const PopupModal = ({
                        bodyContent,
                        show,
                        headerIcon,
                        title,
                        onHide,
                        onShow,
                        description,
                        primaryButton,
                        cancelButton,
                        headerIconClassName,
                        secondaryButton,
                        loading
                    }: Props) => {
    const {t} = useTranslation();
    const modalRef = useRef<HTMLDivElement>(null);
    const [isFullHeight, setIsFullHeight] = useState(false);

    useLayoutEffect(() => {
        if (show) {
            checkHeight();
            window.addEventListener('resize', checkHeight);

            return () => {
                window.removeEventListener('resize', checkHeight);
            };
        }
    }, [show, bodyContent, title]);

    const checkHeight = () => {
        if (modalRef.current) {
            const modalContent = document.querySelector('.popup-modal .modal-content');
            if (modalContent instanceof HTMLElement) {
                const modalHeight = modalContent?.offsetHeight;
                const viewportHeight = window.innerHeight;
                setIsFullHeight(modalHeight >= viewportHeight);
            }
        }
    };

    const renderComponent = (smallComponent?: boolean) => {
        return (
            <Modal dialogClassName="modal-full"
                   className={`popup-modal ${isFullHeight ? "popup-modal--full-height" : ""}`} show={show}
                   onHide={() => IframeWidget.onHide(onHide)}
                   onShow={() => IframeWidget.onShow(onShow)}
                   aria-labelledby="popup-modal-title"
                   centered={!smallComponent}
                   ref={modalRef}
            >
                <Modal.Header>
                    <button onClick={() => IframeWidget.onHide(onHide)} className="btn-close"
                            data-bs-dismiss="modal" aria-label={t("common.action.close")}/>
                </Modal.Header>
                <Modal.Body>
                    {loading ? <LoadingContainer/> : (
                        <>
                            <div className="popup-modal-header">
                                {headerIcon &&
                                    <RoundedIcon icon={headerIcon} className={`mb-4 ${headerIconClassName}`}/>}
                                <h1 id="popup-modal-title">{title}</h1>
                                <p className="text-center">
                                    {description}
                                </p>
                            </div>
                            {bodyContent}
                            {(primaryButton || cancelButton || secondaryButton) && (
                                <div className="popup-modal-footer">
                                    {cancelButton && !secondaryButton &&
                                        <button className="btn btn-default" onClick={() => IframeWidget.onHide(onHide)}>
                                            {t("common.action.cancel")}
                                        </button>}
                                    {secondaryButton}
                                    {primaryButton}
                                </div>
                            )}
                        </>
                    )}
                </Modal.Body>
            </Modal>
        )
    }

    return (
        <ResponsiveComponent breakpoint={768} small={renderComponent(true)} large={renderComponent()}/>
    )
}

export default PopupModal;